import { ArrowUp } from "react-bootstrap-icons";
import { SocialLinks } from "./SocialLinks";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <p className="footer-name">Khushi Tulsiyan</p>
          <p className="footer-role">Software Engineer</p>
        </div>
        <SocialLinks className="footer-social" />
      </div>
      <div className="footer-bottom">
        <p>Copyright {new Date().getFullYear()}. All Rights Reserved</p>
        <a href="#top" className="back-to-top">Back to top <ArrowUp size={14} aria-hidden="true" /></a>
      </div>
    </footer>
  )
}
